import { APICallV3Post } from 'reactApp/api/APICall';

export class DownloadZipV3APICall extends APICallV3Post {
    _method = 'zip';
}
